// extracted by mini-css-extract-plugin
module.exports = {"topbarWrapper":"Topbar_topbarWrapper__2Xomm","topbarBack":"Topbar_topbarBack__3Q4Or","title":"Topbar_title__1kJpL","subtitle":"Topbar_subtitle__Pqxtq"};